import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/static/EPdA-Logo-2025_rgb.png")